// Primary and Secondary color consts
export const colorPrimary = "#1d566e";
export const colorSecondary = "#21ABA5";
